import { ReactElement, useEffect } from 'react';
import {
  Loader,
  transformIntegrationPath,
} from '@sc/shared-ui';
import {
  CheckCircleIcon,
  XCircleIcon,
} from '@heroicons/react/24/outline';
import { Tooltip } from 'react-tooltip';
import { useQuery } from '@apollo/client/react';
import { ProjectState } from '@sc/graphql';
import { GQL_QUERY_INDEX_SOURCE_DOCUMENTS } from '../utility/queries';
import { failedReasonLabel } from '../utility/failedReason';

export const SourceDocuments = ({
  sourceUuid,
  state,
}: {
  sourceUuid: string;
  state: ProjectState;
}): ReactElement => {
  const { data, startPolling, stopPolling } = useQuery(
    GQL_QUERY_INDEX_SOURCE_DOCUMENTS,
    {
      variables: {
        dimensionsInput: undefined,
        input: {
          filter: {
            sourceUuid,
          },
          pagination: {
            perPage: 250,
            page: 1,
          },
        },
      },
    }
  );

  useEffect(() => {
    if (
      data?.indexSourceDocuments.items.some(
        (i) => !i.processedAt && !i.failedReason
      )
    ) {
      startPolling(1000);
    } else {
      stopPolling();
    }
    return () => stopPolling();
  }, [data?.indexSourceDocuments.items, startPolling, state, stopPolling]);

  return (
    <>
      {data?.indexSourceDocuments.items.map((i) => (
        <div
          key={i.uuid}
          className="flex items-center text-body-smallest text-text-subtle space-x-2"
        >
          <div className="truncate">
            {i.hostedIntegrationPath &&
              transformIntegrationPath(i.hostedIntegrationPath)}
            <span>{i.title}</span>
          </div>
          {i.processedAt ? (
            <CheckCircleIcon className="size-3 text-primary-400 shrink-0" />
          ) : i.failedReason ? (
            <span
              className="shrink-0 flex"
              data-tooltip-id="source-document-failed"
              data-tooltip-content={failedReasonLabel(i.failedReason)}
            >
              <XCircleIcon className="size-3 text-red-400" />
            </span>
          ) : (
            <Loader className="size-3  shirnk-0" fill="#BBB" />
          )}
        </div>
      )) ?? <Loader className="size-3" />}
      <Tooltip id="source-document-failed" />
    </>
  );
};
